import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


type IconLayoutProps = {
	isCollapsed: boolean;
}

const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	min-height: 45px;
	background-color: rgb(245, 248, 250);
	display: flex;
	align-items: center;
	cursor: pointer;
	padding: 0 20px 0 10px;

	${(p: WithThemeProps) => `
		border: 1px solid ${p.theme.palette.blackStealthy};
	`}
`;

const IconLayout = styled.div`
	display: inline-flex;
	transform-origin: 50% 50%;
	transition: transform .2s ease-in-out;

	${(p: IconLayoutProps) => p.isCollapsed && `
		transform: rotate(-90deg);
	`}
`;

const ContentLayout = styled.div`
	flex: 1 1 auto;
	padding-left: 10px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export {
	Root,
	IconLayout,
	ContentLayout,
}